import React, { useEffect } from 'react';
import { TopNavigation } from '@amzn/awsui-components-react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../state/store';
import usePlmInstances from './../hooks/usePlmInstances';
import { setPlmId, RetrievePlmStatusType } from '../../state/plmSlice';

export default function CustomTopNavigation() {
    const dispatch = useDispatch();
    const { plmId, retrievePlmStatus } = useSelector((state: RootState) => state.plm);
    const { plmIdOptions, setPlmIdOptions, retrievePlmInstances } = usePlmInstances();
    const onPlmIdSelectHandler = (event) => {
        const selectedPlmId = event.detail.id;
        if (selectedPlmId) {
            dispatch(setPlmId(selectedPlmId));
            setPlmIdOptions((prevs) => {
                return prevs.map((item) => {
                    if (item.id === selectedPlmId) {
                        return { ...item, iconName: 'check' };
                    } else {
                        return { ...item, iconName: undefined };
                    }
                });
            });
        }
    };

    useEffect(() => {
        retrievePlmInstances();
    }, [retrievePlmInstances]);

    return (
        <TopNavigation
            identity={{
                href: '/parts',
                title: 'Compliance Crow'
            }}
            utilities={[
                {
                    type: 'menu-dropdown',
                    text:
                        retrievePlmStatus === RetrievePlmStatusType.Loading
                            ? 'Loading PLM...'
                            : plmId
                              ? `PlmId: ${plmId}`
                              : 'Select a PlmID',
                    ariaLabel: 'PLM ID',
                    description:
                        retrievePlmStatus === RetrievePlmStatusType.Loading
                            ? 'Loading PLM instances'
                            : retrievePlmStatus === RetrievePlmStatusType.Finished
                              ? 'Choose the PLM ID to use throughout the application'
                              : 'Failed to fetch plm instances',
                    items: plmIdOptions,
                    onItemClick: onPlmIdSelectHandler
                }
            ]}
        />
    );
}
